export const translations = {
  es: {
    appName: "LinguAlfred",
    subtitle: "Lenguas sin fronteras",
    translateAnything: "Traduce cualquier texto, en cualquier lugar",
    poweredBy: "Impulsado por múltiples motores de traducción para máxima precisión",
    from: "De",
    to: "A",
    enterText: "Ingresa texto",
    translation: "Traducción",
    typeHere: "Escribe, pega o dicta tu texto aquí...",
    translationHere: "La traducción aparecerá aquí...",
    detected: "Detectado",
    listen: "Escuchar",
    copy: "Copiar",
    clear: "Limpiar",
    clearAll: "Limpiar todo",
    translateNow: "Traducir ahora",
    translationHistory: "Historial de traducciones",
    noHistory: "No hay traducciones en el historial",
    clearHistory: "Limpiar historial",
    translationFailed: "Error en la traducción. Por favor intenta nuevamente.",
    characters: "caracteres",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "Una aplicación de",
    detectLanguage: "Detectar idioma",
    searchLanguages: "Buscar idiomas...",
    noLanguagesFound: "No se encontraron idiomas",
    stop: "Detener",
    selectVoice: "Seleccionar voz",
    sourceVoice: "Voz fuente",
    targetVoice: "Voz traducción",
    voicesAvailable: "voces disponibles",
    testVoice: "Probar voz",
    noVoicesAvailable: "No hay voces disponibles para este idioma",
    local: "Local",
    loading: "Cargando..."
  },
  en: {
    appName: "LinguAlfred",
    subtitle: "Languages without borders",
    translateAnything: "Translate any text, anywhere",
    poweredBy: "Powered by multiple translation engines for maximum accuracy",
    from: "From",
    to: "To",
    enterText: "Enter text",
    translation: "Translation",
    typeHere: "Type, paste, or speak your text here...",
    translationHere: "Translation will appear here...",
    detected: "Detected",
    listen: "Listen",
    copy: "Copy",
    clear: "Clear",
    clearAll: "Clear all",
    translateNow: "Translate now",
    translationHistory: "Translation history",
    noHistory: "No translations in history",
    clearHistory: "Clear history",
    translationFailed: "Translation failed. Please try again.",
    characters: "characters",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "An application by",
    detectLanguage: "Detect language",
    searchLanguages: "Search languages...",
    noLanguagesFound: "No languages found",
    stop: "Stop",
    selectVoice: "Select voice",
    sourceVoice: "Source voice",
    targetVoice: "Target voice",
    voicesAvailable: "voices available",
    testVoice: "Test voice",
    noVoicesAvailable: "No voices available for this language",
    local: "Local",
    loading: "Loading..."
  },
  pt: {
    appName: "LinguAlfred",
    subtitle: "Línguas sem fronteiras",
    translateAnything: "Traduza qualquer texto, em cualquier lugar",
    poweredBy: "Alimentado por múltiplos motores de tradução para máxima precisão",
    from: "De",
    to: "Para",
    enterText: "Digite texto",
    translation: "Tradução",
    typeHere: "Digite, cole ou fale seu texto aquí...",
    translationHere: "A tradução aparecerá aqui...",
    detected: "Detectado",
    listen: "Ouvir",
    copy: "Copiar",
    clear: "Limpar",
    clearAll: "Limpar tudo",
    translateNow: "Traduzir agora",
    translationHistory: "Histórico de traduções",
    noHistory: "Nenhuma tradução no histórico",
    clearHistory: "Limpar histórico",
    translationFailed: "Falha na tradução. Tente novamente.",
    characters: "caracteres",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "Um aplicativo de",
    detectLanguage: "Detectar idioma",
    searchLanguages: "Pesquisar idiomas...",
    noLanguagesFound: "Nenhum idioma encontrado",
    stop: "Parar",
    selectVoice: "Selecionar voz",
    sourceVoice: "Voz origem",
    targetVoice: "Voz tradução",
    voicesAvailable: "vozes disponibles",
    testVoice: "Testar voz",
    noVoicesAvailable: "Não há vozes disponíveis para este idioma",
    local: "Local",
    loading: "Carregando..."
  },
  fr: {
    appName: "LinguAlfred",
    subtitle: "Langues sans frontières",
    translateAnything: "Traduisez n'importe quel texte, n'importe où",
    poweredBy: "Alimenté par plusieurs moteurs de traduction pour une précision maximale",
    from: "De",
    to: "À",
    enterText: "Saisir du texte",
    translation: "Traduction",
    typeHere: "Tapez, collez ou dictez votre texte ici...",
    translationHere: "La traduction apparaîtra ici...",
    detected: "Détecté",
    listen: "Écouter",
    copy: "Copier",
    clear: "Effacer",
    clearAll: "Tout effacer",
    translateNow: "Traduire maintenant",
    translationHistory: "Historique des traductions",
    noHistory: "Aucune traduction dans l'historique",
    clearHistory: "Effacer l'historique",
    translationFailed: "Échec de la traduction. Veuillez réessayer.",
    characters: "caractères",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "Une application par",
    detectLanguage: "Détecter la langue",
    searchLanguages: "Rechercher des langues...",
    noLanguagesFound: "Aucune langue trouvée",
    stop: "Arrêter",
    selectVoice: "Sélectionner la voix",
    sourceVoice: "Voix source",
    targetVoice: "Voix traduction",
    voicesAvailable: "voix disponibles",
    testVoice: "Tester la voix",
    noVoicesAvailable: "Aucune voz disponible pour cette langue",
    local: "Local",
    loading: "Chargement..."
  },
  de: {
    appName: "LinguAlfred",
    subtitle: "Sprachen ohne grenzen",
    translateAnything: "Übersetzen sie jeden text, überall",
    poweredBy: "Angetrieben von mehreren übersetzungsmaschinen für maximale genauigkeit",
    from: "Von",
    to: "Nach",
    enterText: "Text eingeben",
    translation: "Übersetzung",
    typeHere: "Geben sie ihren text aquí ein, fügen sie ihn ein oder sprechen sie...",
    translationHere: "Die übersetzung wird hier erscheinen...",
    detected: "Erkannt",
    listen: "Anhören",
    copy: "Kopieren",
    clear: "Löschen",
    clearAll: "Alles löschen",
    translateNow: "Jetzt übersetzen",
    translationHistory: "Übersetzungshistorie",
    noHistory: "Keine übersetzungen im verlauf",
    clearHistory: "Verlauf löschen",
    translationFailed: "Übersetzung fehlgeschlagen. Bitte versuchen sie es erneut.",
    characters: "Zeichen",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "Eine Anwendung von",
    detectLanguage: "Sprache erkennen",
    searchLanguages: "Sprachen suchen...",
    noLanguagesFound: "Keine Sprachen gefunden",
    stop: "Stoppen",
    selectVoice: "Stimme auswählen",
    sourceVoice: "Quellstimme",
    targetVoice: "Zielstimme",
    voicesAvailable: "stimmen verfügbar",
    testVoice: "Stimme testen",
    noVoicesAvailable: "Keine Stimmen für diese Sprache verfügbar",
    local: "Lokal",
    loading: "Laden..."
  },
  it: {
    appName: "LinguAlfred",
    subtitle: "Lingue senza frontiere",
    translateAnything: "Traduci qualsiasi testo, ovunque",
    poweredBy: "Alimentato da più motori di traduzione per la massima precisione",
    from: "Da",
    to: "A",
    enterText: "Inserisci testo",
    translation: "Traduzione",
    typeHere: "Digita, incolla o detta il tuo testo qui...",
    translationHere: "La traduzione apparirà aquí...",
    detected: "Rilevato",
    listen: "Ascolta",
    copy: "Copia",
    clear: "Cancella",
    clearAll: "Cancella tutto",
    translateNow: "Traduci ora",
    translationHistory: "Cronologia traduzioni",
    noHistory: "Nessuna traduzione nella cronologia",
    clearHistory: "Cancella cronologia",
    translationFailed: "Traduzione fallita. Riprova.",
    characters: "caratteri",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "Un'applicazione di",
    detectLanguage: "Rileva lingua",
    searchLanguages: "Cerca lingue...",
    noLanguagesFound: "Nessuna lingua trovata",
    stop: "Ferma",
    selectVoice: "Seleziona voce",
    sourceVoice: "Voce sorgente",
    targetVoice: "Voce traduzione",
    voicesAvailable: "voci disponibili",
    testVoice: "Prova voce",
    noVoicesAvailable: "Nessuna voce disponibile per questa lingua",
    local: "Locale",
    loading: "Caricamento..."
  },
  zh: {
    appName: "LinguAlfred",
    subtitle: "语言无国界",
    translateAnything: "随时随地翻译任何文本",
    poweredBy: "由多个翻译引擎驱动，确保最高精度",
    from: "从",
    to: "到",
    enterText: "输入文本",
    translation: "翻译",
    typeHere: "在此输入、粘贴或说出您的文本...",
    translationHere: "翻译将在此处显示...",
    detected: "检测到",
    listen: "收听",
    copy: "复制",
    clear: "清除",
    clearAll: "全部清除",
    translateNow: "立即翻译",
    translationHistory: "翻译历史",
    noHistory: "历史记录中没有翻译",
    clearHistory: "清除历史",
    translationFailed: "翻译失败。请重试。",
    characters: "字符",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "的一个应用，由",
    detectLanguage: "检测语言",
    searchLanguages: "搜索语言...",
    noLanguagesFound: "未找到语言",
    stop: "停止",
    selectVoice: "选择语音",
    sourceVoice: "源语音",
    targetVoice: "目标语音",
    voicesAvailable: "个语音可用",
    testVoice: "测试语音",
    noVoicesAvailable: "此语言没有可用语音",
    local: "本地",
    loading: "加载中..."
  },
  ja: {
    appName: "LinguAlfred",
    subtitle: "国境のない言語",
    translateAnything: "いつでもどこでもあらゆるテキストを翻訳",
    poweredBy: "最高精度のために複数の翻訳エンジンで駆動",
    from: "から",
    to: "へ",
    enterText: "テキストを入力",
    translation: "翻訳",
    typeHere: "ここにテキストを入力、貼り付け、または話してください...",
    translationHere: "翻訳がここに表示されます...",
    detected: "検出された",
    listen: "聞く",
    copy: "コピー",
    clear: "クリア",
    clearAll: "すべてクリア",
    translateNow: "今すぐ翻訳",
    translationHistory: "翻訳履歴",
    noHistory: "履歴に翻訳がありません",
    clearHistory: "履歴をクリア",
    translationFailed: "翻訳に失敗しました。もう一度お試しください。",
    characters: "文字",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "によるアプリ、",
    detectLanguage: "言語を検出",
    searchLanguages: "言語を検索...",
    noLanguagesFound: "言語が見つかりません",
    stop: "停止",
    selectVoice: "音声を選択",
    sourceVoice: "ソース音声",
    targetVoice: "ターゲット音声",
    voicesAvailable: "音声が利用可能",
    testVoice: "音声をテスト",
    noVoicesAvailable: "この言語で利用可能な音声がありません",
    local: "ローカル",
    loading: "読み込み中..."
  },
  ko: {
    appName: "LinguAlfred",
    subtitle: "국경 없는 언어",
    translateAnything: "언제 어디서나 모든 텍스트를 번역",
    poweredBy: "최고 정확도를 위한 다중 번역 엔진 구동",
    from: "에서",
    to: "로",
    enterText: "텍스트 입력",
    translation: "번역",
    typeHere: "여기에 텍스트를 입력하거나 붙여넣거나 말하세요...",
    translationHere: "번역이 여기에 나타납니다...",
    detected: "감지됨",
    listen: "듣기",
    copy: "복사",
    clear: "지우기",
    clearAll: "모두 지우기",
    translateNow: "지금 번역",
    translationHistory: "번역 기록",
    noHistory: "기록에 번역이 없습니다",
    clearHistory: "기록 지우기",
    translationFailed: "번역 실패. 다시 시도하세요.",
    characters: "문자",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "의 앱,",
    detectLanguage: "언어 감지",
    searchLanguages: "언어 검색...",
    noLanguagesFound: "언어를 찾을 수 없습니다",
    stop: "중지",
    selectVoice: "음성 선택",
    sourceVoice: "소스 음성",
    targetVoice: "대상 음성",
    voicesAvailable: "음성 사용 가능",
    testVoice: "음성 테스트",
    noVoicesAvailable: "이 언어에 사용 가능한 음성이 없습니다",
    local: "로컬",
    loading: "로딩 중..."
  },
  pl: {
    appName: "LinguAlfred",
    subtitle: "Języki bez granic",
    translateAnything: "Tłumacz dowolny tekst, wszędzie",
    poweredBy: "Zasilany przez wiele silników tłumaczenia dla maksymalnej dokładności",
    from: "Z",
    to: "Na",
    enterText: "Wprowadź tekst",
    translation: "Tłumaczenie",
    typeHere: "Wpisz, wklej lub powiedz swój tekst tutaj...",
    translationHere: "Tłumaczenie pojawi się tutaj...",
    detected: "Wykryto",
    listen: "Słuchaj",
    copy: "Kopiuj",
    clear: "Wyczyść",
    clearAll: "Wyczyść wszystko",
    translateNow: "Tłumacz teraz",
    translationHistory: "Historia tłumaczeń",
    noHistory: "Brak tłumaczeń w historii",
    clearHistory: "Wyczyść historię",
    translationFailed: "Tłumaczenie nie powiodło się. Spróbuj ponownie.",
    characters: "znaków",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "Aplikacja od",
    detectLanguage: "Wykryj język",
    searchLanguages: "Szukaj języków...",
    noLanguagesFound: "Nie znaleziono języków",
    stop: "Zatrzymaj",
    selectVoice: "Wybierz głos",
    sourceVoice: "Głos źródłowy",
    targetVoice: "Głos docelowy",
    voicesAvailable: "dostępnych głosów",
    testVoice: "Testuj głos",
    noVoicesAvailable: "Brak dostępnych głosów dla tego języka",
    local: "Lokalny",
    loading: "Ładowanie..."
  },
  ro: {
    appName: "LinguAlfred",
    subtitle: "Limbi fără frontiere",
    translateAnything: "Traduceți orice text, oriunde",
    poweredBy: "Alimentat de mai multe motoare de traducere pentru precizie maximă",
    from: "Din",
    to: "În",
    enterText: "Introduceți text",
    translation: "Traducere",
    typeHere: "Tastați, lipiți sau spuneți textul aici...",
    translationHere: "Traducerea va apărea aici...",
    detected: "Detectat",
    listen: "Ascultă",
    copy: "Copiază",
    clear: "Șterge",
    clearAll: "Șterge tot",
    translateNow: "Traduceți acum",
    translationHistory: "Istoricul traducerilor",
    noHistory: "Nu există traduceri în istoric",
    clearHistory: "Șterge istoricul",
    translationFailed: "Traducerea a eșuat. Vă rugăm să încercați din nou.",
    characters: "caractere",
    copyright: "© 2026, Alfredo Menéndez",
    anAppBy: "O aplicație de",
    detectLanguage: "Detectează limba",
    searchLanguages: "Căutați limbi...",
    noLanguagesFound: "Nu s-au găsit limbi",
    stop: "Oprește",
    selectVoice: "Selectați vocea",
    sourceVoice: "Vocea sursă",
    targetVoice: "Vocea țintă",
    voicesAvailable: "voci disponibile",
    testVoice: "Testează vocea",
    noVoicesAvailable: "Nu sunt voci disponibile pentru această limbă",
    local: "Local",
    loading: "Se încarcă..."
  }
};

export const appLanguages = [
  { code: 'es', name: 'Español', flag: '🇨🇴' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' }
];